import React from 'react';

import { ApyChart } from './ApyChart';

import { Text, TextSize, TextType } from '@/shared/ui';
import { HistoryItem } from '@/shared/api/borrow';

interface DescriptionProps {
    description: string;
    chart: HistoryItem[];
}

export const Description: React.FC<DescriptionProps> = ({ description, chart }) => {
    return (
        <div className='flex flex-col gap-6 w-full'>
            <Text type={TextType.Paragraph} size={TextSize.LG} name='description'>
                {description}
            </Text>
            <div className='rounded-lg border bg-card text-card-foreground shadow-sm w-full'>
                <ApyChart chart={chart} />
            </div>
        </div>
    );
};
